import { LayoutTemplate } from "../LayoutTemplate";
import * as S from "./styles";
import { InputDate } from "../../Atoms/Inputs/InputDate";
import { Button } from "../../Atoms/Button";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts";
import { useHome } from "./useHome";
import { maskMoney } from "../../../utils/masks";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { ISelectOptions } from "../../../types/inputs";
import dayjs from "dayjs";
import { KeyMetrics } from "../../Atoms/KeyMetrics";

export const GeneralTemplate = () => {
  const {
    control,
    handleSubmit,
    Controller,
    downloadExcelReport,
    dataGeral,
    axisLinear,
    dataLinear,
    CidadeOptions,
    GraphColors,
    handleFilter,
  } = useHome();

  return (
    <LayoutTemplate title="Relatórios de Produção Geral">
      <S.FormDateFilter onSubmit={handleSubmit(handleFilter)}>
        <div>
          <S.Label>Data Inicial</S.Label>
          <Controller
            control={control}
            name="dataInicio"
            render={({ field: { onChange, value } }) => (
              <InputDate
                required
                showIcon
                selected={value && dayjs(value).toDate()}
                placeholderText="___/___/___"
                onChange={(e) => onChange(dayjs(e).format("YYYY-MM-DD"))}
              />
            )}
          />
        </div>
        <div>
          <S.Label>Data Final</S.Label>
          <Controller
            control={control}
            name="dataFim"
            render={({ field: { onChange, value } }) => (
              <InputDate
                required
                showIcon
                maxDate={new Date()}
                selected={value && dayjs(value).toDate()}
                placeholderText="___/___/___"
                onChange={(e) => onChange(dayjs(e).format("YYYY-MM-DD"))}
              />
            )}
          />
        </div>
        <div>
          <S.Label>Empresa</S.Label>
          <Controller
            control={control}
            name="empresa"
            render={({ field: { value, onChange } }) => (
              <SimpleSelect
                options={CidadeOptions}
                isClearable
                value={CidadeOptions.find((i) => i.value === value) || null}
                onChange={(e: ISelectOptions) => onChange(e?.value)}
              />
            )}
          />
        </div>
        <div>
          <S.Label></S.Label>
          <Button>Filtrar</Button>
        </div>
      </S.FormDateFilter>
      <S.WrapperListCards>
        <S.ListCards>
          <KeyMetrics
            title="Ticket Médio"
            value={maskMoney(dataGeral?.ticketMedio) || "R$ 0,00"}
          />
          <KeyMetrics title="Revistorias" value={dataGeral?.revistorias | 0} />
          <KeyMetrics title="Qtd. R$ 152,00" value={dataGeral?.qtd152 | 0} />
          <KeyMetrics title="Qtd. R$ 190,00" value={dataGeral?.qtd190 | 0} />

          <KeyMetrics title="Total Loja" value={dataGeral?.totalLoja | 0} />
          <KeyMetrics title="Total Móvel" value={dataGeral?.totalMovel | 0} />
          <KeyMetrics
            title="Total Itinerante"
            value={dataGeral?.totalItinerante | 0}
          />
          <KeyMetrics
            title="Qtd. Primeiro Emplacamento"
            value={dataGeral?.qtdPrimeiroEmplacamento | 0}
          />
          <KeyMetrics
            title="td. Transferência"
            value={dataGeral?.qtdTransferencia | 0}
          />

          <KeyMetrics
            isActive
            title="Vistorias Líquidas"
            value={
              dataGeral?.totalVistorias != null && dataGeral?.totalVistorias > 0
                ? dataGeral?.totalVistorias - dataGeral?.revistorias
                : 0
            }
          />

          <KeyMetrics
            isActive
            title="Total Vistorias"
            value={dataGeral?.totalVistorias | 0}
          />
        </S.ListCards>
      </S.WrapperListCards>
      <S.FlexWrapperGraficos>
        <S.CardVistoria>
          <S.TitleCard>Vistorias (%)</S.TitleCard>
          <BarChart
            margin={{
              bottom: 70,
            }}
            height={340}
            xAxis={[{ scaleType: "band", data: ["R$ 152,00", "R$ 190,00"] }]}
            slotProps={{
              legend: {
                position: {
                  vertical: "bottom",
                  horizontal: "right",
                },

                labelStyle: { fontSize: 12 },
                itemMarkWidth: 10,
                itemMarkHeight: 10,
                markGap: 5,
                itemGap: 10,
              },
            }}
            series={
              dataGeral?.empresas?.map((item) => ({
                data: [item.per152, item.per190],
                label: item?.empresa,
                color: GraphColors[item?.empresa],
                valueFormatter: (value) => `${value} %`,
              })) || []
            }
            skipAnimation={true}
          />
        </S.CardVistoria>
        <S.CardProducao>
          <S.TitleCard>PRODUÇÃO DIÁRIA TOTAL DE VISTORIAS</S.TitleCard>

          <LineChart
            height={340}
            margin={{
              bottom: 70,
            }}
            series={dataLinear || []}
            xAxis={[{ scaleType: "band", data: axisLinear || [] }]}
            slotProps={{
              legend: {
                position: {
                  vertical: "bottom",
                  horizontal: "right",
                },
                labelStyle: { fontSize: 12 },
                itemMarkWidth: 10,
                itemMarkHeight: 10,
                markGap: 5,
                itemGap: 10,
              },
            }}
          />
        </S.CardProducao>
      </S.FlexWrapperGraficos>
      <S.ExportButton onClick={downloadExcelReport}>
        <img src={"/assets/svg/export-icon.svg"} alt="icone exportacao" />{" "}
        Exportar
      </S.ExportButton>

      <S.Table>
        <S.TableHead>
          <h4>Empresa</h4>
          <h4>Unidade</h4>
          <h4 className="center">Loja</h4>
          <h4 className="center">Móvel</h4>
          <h4 className="center">Itinerante</h4>
          <h4 className="center">Revistorias</h4>
          <h4 className="center">R$ 152,00</h4>
          <h4 className="center">R$ 190,00</h4>
          <h4 className="center">Ticket Médio</h4>
          <h4 className="center">Líquido</h4>
          <h4 className="center">Total</h4>
        </S.TableHead>
        {dataGeral?.lojas?.map((item) => (
          <S.TableRow key={Math.random()}>
            <p>{item?.empresa || "---"}</p>
            <p>{item?.loja || "---"}</p>
            <p className="center">{item?.qtdLoja || 0}</p>
            <p className="center">{item?.qtdMovel || 0}</p>
            <p className="center">{item?.qtdItinerante || 0}</p>
            <p>{item?.revistorias || 0}</p>
            <p className="center">{item.qtd152 || 0}</p>
            <p className="center">{item.qtd190 || 0}</p>
            <p className="center">{maskMoney(item.ticketMedio) || 0}</p>
            <p className="center">
              {item?.total != null && item?.total > 0
                ? item?.total - item?.revistorias
                : 0}
            </p>
            <p className="center">{item.total || 0}</p>
          </S.TableRow>
        ))}
      </S.Table>
    </LayoutTemplate>
  );
};
